import {Dispatch} from "redux";
import {getContainer} from "../ioc/IOCSetup";
import {
    DepositContext,
    DepositResult,
    PaymentDialog,
    PaymentMethod,
    PaymentType,
    PlayerOrder,
    TransferLimit
} from "../http/protocol";
import {AppState} from "../RootReducer";
import {CashierSection, DepositPhase, MethodAndDepositContext} from "./PaymentsReducer";
import {fetchBalance} from "../user/UserActions";


export enum DepositActionType {
    SHOW_DEPOSIT = "@payments/deposit/show",
    SHOW_CASHIER = "@payments/cashier/show",
    SELECT_CURRENCY = "@payments/deposit/selectCurrency",
    INIT_DEPOSIT_REQUEST = "@payments/deposit/init/request",
    INIT_DEPOSIT_RESPONSE = "@payments/deposit/init/response",
    INIT_DEPOSIT_RESULT = "@payments/deposit/init/result",
    INIT_DEPOSIT_ERROR = "@payments/deposit/init/request/error",
    SELECT_METHOD = "@payments/providers/select",
    UPDATE_AMOUNT = "@payments/deposit/amount/update",
    UPDATE_ADDRESS = "@payments/deposit/address/update",
    SHOW_POSSIBLE_DEPOSIT_ERRORS = "@payments/deposit/show/errors",
    SET_USE_AS_STORE = "@payments/useasstore/set",
    SET_SENDING_PAYMENT = "@payments/sendingPayment/set",
    SET_SENDING_PAYMENT_FAILED = "@payments/sendingPayment/failed",
    DEPOSIT_CONTEXT_REQUEST = "@payments/deposit/context/request",
    DEPOSIT_CONTEXT_RESPONSE = "@payments/deposit/context/response",
    DEPOSIT_CONTEXT_ERROR = "@payments/deposit/context/error",
    UPDATE_PHASE = "@payments/deposit/phase/update",
    RESET_ERROR = "@payments/deposit/reset/error",
    RESET_DEPOSIT_CONTEXT = "@payments/deposit/reset/context",
    RESET_DEPOSIT_STATUS_AND_CONTEXT = "@payments/deposit/reset/status/and/context"
}
export type DepositActions =
    | { type : DepositActionType.SHOW_CASHIER, show : boolean, section? : CashierSection }
    | { type : DepositActionType.INIT_DEPOSIT_REQUEST, request : { provider : string, order : PlayerOrder, amount? : string, activeCurrency?: string }}
    | { type : DepositActionType.INIT_DEPOSIT_RESPONSE, dialog : PaymentDialog, instantDeposit?: boolean }
    | { type : DepositActionType.INIT_DEPOSIT_RESULT, depositResult : DepositResult}
    | { type : DepositActionType.INIT_DEPOSIT_ERROR, error : Error }
    | { type : DepositActionType.SELECT_METHOD, method : PaymentMethod, currencyCode: string }
    | { type : DepositActionType.SELECT_CURRENCY, currency : string }
    | { type : DepositActionType.UPDATE_AMOUNT, amount : string, limit? : TransferLimit }
    | { type : DepositActionType.UPDATE_ADDRESS, address : string }
    | { type : DepositActionType.SET_USE_AS_STORE, useAsStore: boolean  }
    | { type : DepositActionType.SET_SENDING_PAYMENT, sendingPayment: boolean}
    | { type : DepositActionType.SET_SENDING_PAYMENT_FAILED, sendingPaymentFailed: boolean}
    | { type : DepositActionType.UPDATE_PHASE, phase : DepositPhase }
    | { type : DepositActionType.DEPOSIT_CONTEXT_REQUEST}
    | { type : DepositActionType.DEPOSIT_CONTEXT_ERROR }
    | { type : DepositActionType.DEPOSIT_CONTEXT_RESPONSE, method : PaymentMethod, context : DepositContext, currencyCode : string }
    | { type : DepositActionType.SHOW_POSSIBLE_DEPOSIT_ERRORS }
    | { type : DepositActionType.RESET_ERROR }
    | { type : DepositActionType.RESET_DEPOSIT_CONTEXT }
    | { type : DepositActionType.RESET_DEPOSIT_STATUS_AND_CONTEXT };

export const updateDepositPhase = (phase:DepositPhase) => {
    return {type:DepositActionType.UPDATE_PHASE, phase:phase}
}

export const resetDepositContext = () => {
    return { type : DepositActionType.RESET_DEPOSIT_CONTEXT };
}

export const resetDepositStatusAndContext = () => {
    return { type : DepositActionType.RESET_DEPOSIT_STATUS_AND_CONTEXT };
}

export const updateDepositAmount = (amount : string) => {
    return { type : DepositActionType.UPDATE_AMOUNT, amount : amount};
}
export const updateDepositAddress = (address : string) => {
    return { type : DepositActionType.UPDATE_ADDRESS, address : address};
}
export const showPossibleDepositErrors = () => {
    return { type : DepositActionType.SHOW_POSSIBLE_DEPOSIT_ERRORS};
}
export const showCashier = (show : boolean, section?: CashierSection): DepositActions => (
    { type : DepositActionType.SHOW_CASHIER, show : show, section : section }
)


export const setUseAsStore = (useAsStore : boolean) : DepositActions => {
    return { type : DepositActionType.SET_USE_AS_STORE, useAsStore : useAsStore};
}

export const showDepositResult = (depositResult: DepositResult): DepositActions => {
    return { type : DepositActionType.INIT_DEPOSIT_RESULT, depositResult: depositResult };
}

export const isSendingPayment = (sendingPayment : boolean) : DepositActions => {
    return { type : DepositActionType.SET_SENDING_PAYMENT, sendingPayment : sendingPayment};
};

export const isSendingPaymentFailed = (sendingPaymentFailed : boolean) : DepositActions => {
    return { type : DepositActionType.SET_SENDING_PAYMENT_FAILED, sendingPaymentFailed};
};
export function initDeposit(reuseAddressIfPossible : boolean = true) {
    return (dispatch : Dispatch, getState : () => AppState) => {
        let deposit = getState().payments.deposit;
        console.log("Init Deposit", deposit);
        if(deposit.activeMethod &&  deposit.activeMethod.provider) {
            let provider = deposit.activeMethod.provider;
            let amount = deposit.amount;
            let address = deposit.address;
            let activeCurrency = deposit.activeCurrency;
            let order : PlayerOrder  = {
                type : PaymentType.DEPOSIT,
                currencyCode : activeCurrency,
                method : deposit.activeMethod.code,
                reuseAddressIfPossible : reuseAddressIfPossible ? true : false,
                recipientAddress: address
            }
            if(deposit.activeMethod.amountRequired && amount) {
                order = {...order,  amount : parseFloat(amount)}
            } else {
                order = {...order,  amount : 0}
            }
            dispatch({type : DepositActionType.INIT_DEPOSIT_REQUEST, request : { provider : provider, order : provider, amount : deposit.amount, activeCurrency : deposit.activeCurrency}});

            return getContainer().getPaymentsService().getPaymentDialog(deposit.activeMethod.provider, order).then((d : PaymentDialog)=>{
                fetchBalance();
                dispatch({ type : DepositActionType.INIT_DEPOSIT_RESPONSE, dialog : d, instantDeposit: deposit.activeMethod?.instantDepositEnabled });
            }).catch(err => {
                dispatch({ type : DepositActionType.INIT_DEPOSIT_ERROR, error : err })
            });
        }
    }
}

export function initStorePurchase(bundleId?: number) {
    return (dispatch : Dispatch, getState : () => AppState) => {
        let deposit = getState().payments.deposit;
        if(deposit.activeMethod &&  deposit.activeMethod.provider && bundleId) {
            let provider = deposit.activeMethod.provider;
            let method = deposit.activeMethod.code;
            dispatch({type : DepositActionType.INIT_DEPOSIT_REQUEST, request : { provider : provider, order : provider}});

            getContainer().getBundleService().getPaymentDialog(bundleId, {provider: provider, method: method}).then((d : PaymentDialog)=>{
                dispatch({ type : DepositActionType.INIT_DEPOSIT_RESPONSE, dialog : d });
            }).catch(err => {
                dispatch({ type : DepositActionType.INIT_DEPOSIT_ERROR, error : err })
            });
        }
    }
}
